const restartCssAnimation = ({element, animationClass}) => {
    element.classList.remove(animationClass);
    void element.offsetWidth; // force browser to repaint element
    element.classList.add(animationClass);
};

export {restartCssAnimation};
